// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3PbyA","cell":"ColumnAccessor_cell__mDwly","firstCellAccent":"ColumnAccessor_firstCellAccent__2wE5g"};